module.exports = __webpack_public_path__ + "static/media/facilities-mira-technology-institute.73b2bd68.jpg";